import {User} from '../domain/user';

export class UserUtils {
    public static getDefaultTenant(user: User): string {
        return user.tenantRoles
            .filter(tenantRole => tenantRole.defaultTenant === true)
            .map(tenantRole => tenantRole.tenant)[0];
    }
}
